import React from 'react';
import { motion } from 'framer-motion';

const MenuBack = ({toggle} ) => {
    console.log(toggle)
    return (
        <div className='absolute top-0 left-0 h-screen w-full -z-10'>
            <div className='h-full w-full relative'>
                
                {/* Vertical Lines Animation */}
                <div className='absolute h-full w-full flex justify-between items-end'>
                    <div className='h-full w-px opacity-0'></div>
                    <div className='h-full w-px opacity-0'></div>
                    <div className='h-full w-px opacity-0'></div>
                    <div className='h-full w-px opacity-0'></div>

                    <motion.div
                        className='w-px bg-customGray opacity-20'
                        initial={{ height: '0%' }}
                        animate={{ height: toggle ? '93.64%' : '0%' }}
                        transition={{ duration: 2 }}
                    ></motion.div>

                    <motion.div
                        className='w-px bg-customGray opacity-20'
                        initial={{ height: '0%' }}
                        animate={{ height: toggle ? '86.60%' : '0%' }}
                        transition={{ duration: 2, delay: 0.1 }}
                    ></motion.div>

                    <motion.div
                        className='w-px bg-customGray opacity-20'
                        initial={{ height: '0%' }}
                        animate={{ height: toggle ? '76.05%' : '0%' }}
                        transition={{ duration: 2, delay: 0.2 }}
                    ></motion.div>

                    <div className='h-full w-px opacity-0'></div>
                    <div className='h-full w-px opacity-0'></div>
                </div>

                {/* Horizontal Lines Animation */}
                <div className='absolute h-full w-full flex flex-col justify-between items-end'>
                    <div className='h-px w-full opacity-0'></div>
                    <div className='h-px w-full opacity-0'></div>

                    <motion.div
                        className='h-px bg-customGray opacity-20'
                        initial={{ width: '0%' }}
                        animate={{ width: toggle ? '32.2%' : '0%' }}
                        transition={{ duration: 2 }}
                    ></motion.div>

                    <motion.div
                        className='h-px bg-customGray opacity-20'
                        initial={{ width: '0%' }}
                        animate={{ width: toggle ? '60%' : '0%' }}
                        transition={{ duration: 2, delay: 0.1 }}
                    ></motion.div>

                    <motion.div
                        className='h-px bg-customGray opacity-20'
                        initial={{ width: '0%' }}
                        animate={{ width: toggle ? '41%' : '0%' }}
                        transition={{ duration: 2, delay: 0.2 }}
                    ></motion.div>

                    <motion.div
                        className='h-px bg-customGray opacity-20'
                        initial={{ width: '0%' }}
                        animate={{ width: toggle ? '75%' : '0%' }}
                        transition={{ duration: 2, delay: 0.3 }}
                    ></motion.div>

                    <div className='h-px w-full opacity-0'></div>
                    <div className='h-px w-full opacity-0'></div>
                </div>
            </div>
        </div>
    );
};

export default MenuBack;
